import { httpClient } from '@/modules/common/services/http/http-client';
import { EventsProvisionedList } from '@/modules/trade/views/TradeView/components/TradeSidebar/types';

const baseURL = `${process.env.VUE_APP_BFF_URL}/trade/v1`;
export const httpClientWithDefaultOptions = httpClient.withOptions({ baseURL });

export function getEventsProvisionedList(): Promise<EventsProvisionedList> {
  return httpClientWithDefaultOptions.get('/getProvisionedEvents');
}
